import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { AboutData, AboutPOICard } from './AboutPOICard';

/**
 * Props Definition
 */
export interface AboutPOIProps {
    pointOfInterestName: string;
    description: string;
    address: string;
}

/**
 * Point Of Interests About Container
 */
export const AboutPOI: React.VFC<AboutPOIProps> = ({
    pointOfInterestName,
    description,
    address,
}) => {
    const aboutData: AboutData = {
        title: gettext('About the %(pointOfInterestName)s', {
            pointOfInterestName,
        }),
        content: description,
        address,
    };

    return <AboutPOICard aboutData={aboutData} />;
};
